import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useDeleteOAuthClientMutation({
	onSuccess,
	onError,
	onSettled,
}: {
	onSuccess?: () => void;
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSettled?: () => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (id: string) =>
			userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `oauthclients/${id}`,
				}),
				'DELETE'
			),
		onError,
		onSuccess,
		onSettled,
	});
}
